export default {
    'Close menu': 'Menü schließen',
    'Close submenu': 'Untermenü schließen',
    'Open submenu': 'Untermenü öffnen',
    'Toggle submenu': 'Untermenü wechseln'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/core/screenreader/translations/de.js
// module id = 481
// module chunks = 0